import React from "react";

import BannersSlider from "components/BannersSlider";
import TourBalloon from "components/NewTour/TourBallon";

import { ContentBannerPromotions } from "./PortalPage.styles";

type Props = {
  showTour: boolean;
  tourStep: number;
  tourType: string;
};

const PortalPromoPanel = ({
  showTour,
  tourStep,
  tourType,
}: Props): JSX.Element => {
  const highlight = tourStep === 10 && tourType === "home" && showTour;

  return (
    <ContentBannerPromotions showTour={highlight}>
      <BannersSlider />
      {showTour && tourStep === 10 && tourType === "home" && (
        <TourBalloon
          title="Novidades"
          content="Aqui compartilharemos com você todas as novidades para energizar junto com a Ultragaz!."
          position={{
            left: "0",
            right: "0",
            top: "280px",
            arrowPosition: "top",
            maxWidth: 320,
            arrowTop: "-28px",
          }}
        />
      )}
    </ContentBannerPromotions>
  );
};

export default PortalPromoPanel;
